module.exports = __webpack_public_path__ + "img/info5.f43d77c8.png";